module.exports = __webpack_public_path__ + "media/images/pg-top/higashiomi-sib-2309-4c1475e2d2398f34e87f7271fe1c1e3c.jpg";